module.exports = __webpack_public_path__ + "img/computer-blue.637bb3d4.png";